$(document).ready(function () {

  // ------------------------
  // Custom Menu
  // ------------------------

  function openMenu() {
    const $menu = $('.custom-header-menu');

    $('.header').addClass('custom-menu__open');

    $menu
      .stop(true, true)
      .slideDown(300)
      .css('opacity', 1);
  }

  function closeMenu() {
    const $menu = $('.custom-header-menu');

    $('.header').removeClass('custom-menu__open');

    $menu
      .stop(true, true)
      .css('opacity', 0)
      .slideUp(300);
  }

  function toggleMenu() {
    if ($('.header').hasClass('custom-menu__open')) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  // Click on icon to toggle menu
  $('.custom-header__icon').on('click', function(e) {
    e.stopPropagation();
    toggleMenu();
  });

  // Close menu when clicking outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.header').length) {
      closeMenu();
    }
  });

  // Prevent clicks inside header from closing menu
  $('.header').on('click', function(e) {
    e.stopPropagation();
  });


  // function checkScroll() {
  //   if ($(window).scrollTop() > 50) { // adjust scroll value
  //     $("#header-group").addClass("active-header-group");
  //     $(".header").addClass("active-header");
  //   } else {
  //     $("#header-group").removeClass("active-header-group");
  //     $(".header").removeClass("active-header");
  //   }
  // }

    function checkScroll() {
      if ($(window).scrollTop() > 50) { // adjust scroll value
        $("#header-group").addClass("active-header-group");
        $(".header").addClass("active-header");
      } else {
        if (document.querySelector("cart-drawer-component dialog")?.hasAttribute('open')) return;

        $("#header-group").removeClass("active-header-group");
        $(".header").removeClass("active-header");
      }
    }

  // Run on scroll
  $(window).on("scroll", checkScroll);

  // Run on page load
  $(document).ready(function () {
    checkScroll();
  });



  // ------------------------
  // Resource List Slider
  // ------------------------
  (function () {
    const $slider = $('.custom-section-resource-list .resource-list-grid');

    if ($slider.length) {
      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        variableWidth: true,

        responsive: [
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: false
            }
          }
        ]
      });

      $('.prev__arrow').on('click', function () {
        $slider.slick('slickPrev');
      });

      $('.next__arrow').on('click', function () {
        $slider.slick('slickNext');
      });
    }
  })();


  // ------------------------
  // Collection grid Slider
  // ------------------------
  (function () {
    $('.custom-collection-section').each(function () {
      const $section = $(this);
      const $sliderGrid = $section.find('.collection-grid');

      if ($sliderGrid.length) {
        $sliderGrid.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          infinite: true,
          centerMode: true,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 400,
              settings: {
                variableWidth: false,
                centerMode: false,
                slidesToShow: 1
              }
            }
          ]
        });

        $section.find('.prev__arrow-c').on('click', function () {
          $sliderGrid.slick('slickPrev');
        });

        $section.find('.next__arrow-c').on('click', function () {
          $sliderGrid.slick('slickNext');
        });
      }
    });
  })();

  // ------------------------
  // Recommended List Slider
  // ------------------------
  (function () {
    const initSlick = () => {
      const $slider = $('.custom-recommended--product .resource-list');

      if ($slider.length && !$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          infinite: true,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 400,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });

        $('.prev__arrow').on('click', function () {
          $slider.slick('slickPrev');
        });

        $('.next__arrow').on('click', function () {
          $slider.slick('slickNext');
        });
      }
    };

    // Wait for Shopify to render recommendations
    document.addEventListener('shopify:section:load', initSlick);
    document.addEventListener('DOMContentLoaded', initSlick);

    // Fallback (important for async recommendations)
    const observer = new MutationObserver(initSlick);
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  // ------------------------
  // Testimonials Slider
  // ------------------------
  (function () {
    const $slider = $('.custom-testimonials .testimonial--content');

    if ($slider.length) {
      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        centerMode: true,
        variableWidth: true,
        appendDots: $('.custom-testimonials .testimonial-dots'),
        customPaging: function (slider, i) {
          return '<button class="custom-dot">' + (i + 1) + '</button>';
        },

        responsive: [
          {
            breakpoint: 460,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
              variableWidth: false
            }
          }
        ]
      });

      $('.custom-testimonials .prev__arrow').on('click', function () {
        $slider.slick('slickPrev');
      });

      $('.custom-testimonials .next__arrow').on('click', function () {
        $slider.slick('slickNext');
      });
    }
  })();



  
  // ------------------------
  //Video Testimonials Slider
  // ------------------------
  (function () {
    const $slider = $('.custom-video__testimonials .marquee-track');

    function initSlider() {
      if (window.innerWidth <= 1024) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true,
            centerMode: false,
            variableWidth: false
          });
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }

      $('.custom-video__testimonials .prev__arrow').on('click', function () {
        $slider.slick('slickPrev');
      });

      $('.custom-video__testimonials .next__arrow').on('click', function () {
        $slider.slick('slickNext');
      });
    }

    initSlider();
    $(window).on('resize', initSlider);
  })();



  // ------------------------
  //Menu Slider
  // ------------------------
  (function () {

    const $slider = $('.custom-header-menu .featured-products-row');

    function initSlider() {

      if (window.innerWidth <= 1400) {

        if (!$slider.hasClass('slick-initialized')) {

          $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            variableWidth: true,
            infinite: true
          });

        }

      } else {

        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }

      }

    }

    $(document).ready(initSlider);

    $(window).on('resize', function () {

      initSlider();

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }

    });

  })();



    
  // ------------------------
  //How is Works Slider
  // ------------------------
  // (function () {
  //   const $section = $('.custom-hiw');
  //   const $slider = $section.find('.hiw-block__wrapper');

  //   if ($slider.length) {
  //     $slider.slick({
  //       slidesToShow: 3,
  //       slidesToScroll: 1,
  //       arrows: false,
  //       infinite: true,
  //       variableWidth: true,

  //       responsive: [
  //         {
  //           breakpoint: 440,
  //           settings: {
  //             slidesToShow: 1,
  //             slidesToScroll: 1,
  //             centerMode: false,
  //             variableWidth: false
  //           }
  //         }
  //       ]
  //     });

  //     $section.find('.prev__arrow').on('click', function () {
  //       $slider.slick('slickPrev');
  //     });

  //     $section.find('.next__arrow').on('click', function () {
  //       $slider.slick('slickNext');
  //     });
  //   }
  // })();



  // ------------------------
  // Accordion
  // ------------------------
  $('.accordion-block').each(function () {
    const $items = $(this).find('.accordion-each');
    if (!$items.length) return;

    $items.first().addClass('open').find('.accordion-text').show();

    $(this).on('click', '.accordion-title, .accordion-icon', function () {
      const $clicked = $(this).closest('.accordion-each');

      $clicked.toggleClass('open').find('.accordion-text').stop(true, true).slideToggle(300);

      $items.not($clicked).removeClass('open').find('.accordion-text').slideUp(300);
    });
  });




  // ------------------------
  // Tab Accordion
  // ------------------------

$('.custom-tab--accordion').each(function () {
  const $section = $(this);
  const $tabLinks = $section.find('.tab-link');
  const $tabContents = $section.find('.tab-content');

  $tabContents.hide().removeClass('active');
  $tabLinks.removeClass('active');

  $tabLinks.first().addClass('active');
  $tabContents.first().addClass('active').show();

  // 🔥 INITIAL animation
  animateAccordion($tabContents.first());

  $tabLinks.on('click', function (e) {
    e.preventDefault();
    const tabId = $(this).data('tab');

    $tabLinks.removeClass('active');
    $(this).addClass('active');

    // 🔥 RESET ONLY accordion--block
    $tabContents.each(function () {
      $(this)
        .find('.accordion--block')
        .removeClass('is-visible')
        .css('transition-delay', '0s');
    });

    $tabContents.removeClass('active').hide();

    const $activeTab = $section.find('#' + tabId);
    $activeTab.addClass('active').show();

    const $accordions = $activeTab.find('.tab-accordion-each');
    $accordions.removeClass('open').find('.tab-accordion-text').hide();
    $accordions.first().addClass('open').find('.tab-accordion-text').show();

    // 🔥 TRIGGER animation
    animateAccordion($activeTab);
  });

  function animateAccordion($tab) {
    const $items = $tab.find('.accordion--block');

    $items.each(function (index) {
      const $el = $(this);

      $el.css('transition-delay', `${index * 0.15}s`);

      setTimeout(() => {
        $el.addClass('is-visible');
      }, 50);
    });
  }

  // accordion click (unchanged)
  $section.find('.tab-accordion--block').each(function () {
    const $items = $(this).find('.tab-accordion-each');
    if (!$items.length) return;

    if ($(this).closest('.tab-content').hasClass('active')) {
      $items.first().addClass('open').find('.tab-accordion-text').show();
    }

    $(this).on('click', '.tab-accordion-title, .accordion-icon', function () {
      const $clicked = $(this).closest('.tab-accordion-each');

      $clicked.toggleClass('open')
        .find('.tab-accordion-text')
        .stop(true, true)
        .slideToggle(300);

      $items.not($clicked)
        .removeClass('open')
        .find('.tab-accordion-text')
        .stop(true, true)
        .slideUp(300);
    });
  });
});


  // ------------------------
  // Tab Content
  // ------------------------


  $('.custom-tab--content').each(function () {

    var $section = $(this);

    $section.find('.block-each').hide();

    // BUTTON VERSION
    if ($section.find('.tabs-nav').length) {

      var firstTab = $section.find('.tab-link').first().data('tab');
      $section.find('.block-each[data-parent="' + firstTab + '"]').show();

      $section.find('.tab-link').on('click', function () {

        var tabID = $(this).data('tab');

        $section.find('.tab-link').removeClass('active');
        $(this).addClass('active');

        $section.find('.block-each').hide();
        $section.find('.block-each[data-parent="' + tabID + '"]').fadeIn();

      });
    }

    // SELECT VERSION
    if ($section.find('.tabs-select').length) {

      var firstSelect = $section.find('.tabs-select').val();
      $section.find('.block-each[data-parent="' + firstSelect + '"]').show();

      $section.find('.tabs-select').on('change', function () {

        var tabID = $(this).val();

        $section.find('.block-each').hide();
        $section.find('.block-each[data-parent="' + tabID + '"]').fadeIn();

      });
    }

  });




  // ------------------------
  // Input Has Value
  // ------------------------


$(document).on('input', '.custom__input', function () {
  if ($(this).val().trim() !== '') {
    $(this).addClass('has-value');
  } else {
    $(this).removeClass('has-value');
  }
});

 

  // ------------------------
  // Fade In Animation (Modern)
  // ------------------------

  const observer = new IntersectionObserver(function(entries) {

    entries.forEach(function(entry) {

      if (entry.isIntersecting) {
        $(entry.target).addClass('is-visible');
      }

    });

  }, { threshold: 0.2 });


  $('.fade-wrapper').each(function(){

    $(this).find('.fade-in-left, .fade-in-right, .fade-in-up, .fade-in-down').each(function(index){

      // auto stagger delay
      $(this).css('transition-delay', (index * 0.15) + 's');

      observer.observe(this);

    });

  });



  // ------------------------
  // Gradient Background
  // ------------------------
  
  function applySharedGradient() {
    const $allSections = $('.section'); 
    let isInGradient = false;
    let $gradientSections = $();

    $allSections.each(function() {
      if ($(this).hasClass('gradient-start')) {
        isInGradient = true;
        $gradientSections = $().add(this); 
      } else if (isInGradient) {
        $gradientSections = $gradientSections.add(this);
      }

      if ($(this).hasClass('gradient-end') && isInGradient) {
        $gradientSections = $gradientSections.add(this);

        
        const totalHeight = $gradientSections.toArray().reduce((sum, el) => sum + $(el).outerHeight(), 0);
        let currentOffset = 0;

        $gradientSections.each(function() {
          const sectionHeight = $(this).outerHeight();
          $(this).css({
            'background': 'linear-gradient(180deg, #FFFCFA 0%, #FDF7F1 100%)',
            'background-size': `100% ${totalHeight}px`,
            'background-position': `0 -${currentOffset}px`,
            'background-repeat': 'no-repeat'
          });
          currentOffset += sectionHeight;
        });

      
        isInGradient = false;
        $gradientSections = $();
      }
    });
  }

  applySharedGradient();

  $(window).on('resize', function() {
    applySharedGradient();
  });


  // ------------------------
  // Buy Button
  // ------------------------

  setInterval(function () {
    $('.shopify-payment-button__button').text('Buy Now');
  }, 500);






  
  // ------------------------
  // Reading Time
  // ------------------------

  (function () {
    var $readingTime = $("#reading-time-text");
    if ($readingTime.length === 0) return;

    var activeTime = 0;
    var lastActivity = Date.now();
    var isTabActive = true;

    // 🔥 Update UI
    function updateUI() {
      var now = Date.now();
      var totalTime = activeTime;

      // only count time if tab is active
      if (isTabActive) {
        totalTime += (now - lastActivity);
      }

      var seconds = Math.round(totalTime / 1000);
      var minutes = Math.max(1, Math.ceil(seconds / 60));

      $readingTime.text(
        minutes + " Minute" + (minutes > 1 ? "s" : "") + " Reading Time"
      );
    }

    // 🔥 Track activity
    function userActive() {
      var now = Date.now();

      if (isTabActive) {
        activeTime += (now - lastActivity);
      }

      lastActivity = now;
      updateUI(); // instant update
    }

    // 🔥 Throttle mousemove (fires a lot)
    var mouseThrottle = null;
    $(document).on("mousemove", function () {
      if (!mouseThrottle) {
        mouseThrottle = setTimeout(function () {
          userActive();
          mouseThrottle = null;
        }, 1000);
      }
    });

    // Other activity events
    $(document).on("scroll keydown click", userActive);

    // 🔥 Detect tab visibility
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        isTabActive = false;
      } else {
        isTabActive = true;
        lastActivity = Date.now(); // reset timer when returning
      }
    });

    // 🔥 Update every second (smooth)
    var interval = setInterval(updateUI, 1000);

    // 🔥 Cleanup on exit
    $(window).on("beforeunload", function () {
      var now = Date.now();

      if (isTabActive) {
        activeTime += (now - lastActivity);
      }

      clearInterval(interval);
    });

  })();




  
  function updateHeaderOffset() {
    var $announcementBar = $('.announcement-bar');
    var $headerComponent = $('#header-component[sticky="always"]');

    if (!$announcementBar.length || !$headerComponent.length) return;

    var $header = $headerComponent.closest('.header-section');
    if (!$header.length) return;

    // 🔥 more accurate on mobile
    var height = $announcementBar[0].getBoundingClientRect().height;

    // apply with !important to avoid CSS conflicts
    $header[0].style.setProperty('top', height + 'px', 'important');
  }

  // Run when DOM is ready
  $(document).ready(function () {
    updateHeaderOffset();

    // 🔥 run again after layout settles (fix mobile wrap/font issues)
    setTimeout(updateHeaderOffset, 100);
    setTimeout(updateHeaderOffset, 300);
  });

  // Run on resize + orientation change (important for mobile)
  $(window).on('resize orientationchange', function () {
    updateHeaderOffset();
  });







  $('.js-copy-link').on('click', function (e) {
    e.preventDefault();

    var link = $(this).data('link');

    navigator.clipboard.writeText(link)
      .then(function () {
        alert('Link copied!');
      })
      .catch(function (err) {
        console.error('Copy failed:', err);
      });
  });

  




});
